import { Outlet } from "react-router";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SocialMedia from "./components/socialMedia";

export default function Layout() {
  return (
    <div className="bg-[#F5F2E4] overflow-x-hidden h-full">
      <Navbar />
      <main className="w-full">
        <Outlet />
      </main>
      <Footer />

      <SocialMedia
        facebook="https://www.facebook.com/VeganVegetarianMerida"
        whatsapp="529991268546"
        instagram="https://www.instagram.com/veganvegetarianmid?igsh=MWw0bzJ1bW5zcnJvbg=="
      />
    </div>
  );
}
